import { ReactElement } from 'react';

import config from '../config/index.json';

export const Copyright = (): ReactElement => {
    const { about } = config;
    const { socialMedia } = about;

    return (
        <div className='flex items-center mt-6'>
            <p className='mt-6 text-xs lg:text-sm leading-none text-gray-900 dark:text-gray-50'>
                <a href={socialMedia.github} rel='nofollow'>
                    {'Copyright © 2023 Michael Habermas. All Rights Reserved.'}
                </a>
            </p>
        </div>
    );
};
